export default __webpack_public_path__ + "static/media/sophieVaughan.e1aba038.jpg";